/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLocation } from "react-router-dom";
import { DashboardLayout } from "../components/Dashboard";
import { ValidAccessToken, formatDate, formatDate_ddMMYY, pagesRouter } from "../core/function/function-generic";
import { useEffect, useState } from "react";
import SectionTap from "../components/SectionTap";
import { TableGen } from "../components/table-gen";
import { useDispatch, useSelector } from "react-redux";
import { requestHttp } from "../api/services-third-parties";
import { EyeIcon } from "@heroicons/react/24/outline";
import Flag from 'react-world-flags';
import { ModalOperation } from "../components/ModalOperation";

type DevelopersProps = {
    onSearchGen: string;
};

const Developers = ({ onSearchGen }: DevelopersProps) => {
  document.body.style.background="#FFF";
    const location = useLocation();
    const dispatch = useDispatch();
    const state = useSelector((state : any)=>state.business);
    const [ optionActive, setOptionActive ] = useState('API Keys');
    const [open, setOpen] = useState(false);
    const [message,setMessage] = useState('');
    let operation:any;
    const [dataOperation, setdataOperation] = useState(operation);
    const [datatap, setdatatap] = useState([
        { name: 'API Keys', class:'home-title-tap fontPageTitle text-center' }
    ]);

    const [dataTable, setDataTable] = useState({
        columnMap: ['name', 'apiKey', 'createdAt'],
        columns: ['Name',  'Token', 'Created'],
        data: [],
        totalPages: 0,
        isAction:true,
        actionIcon: [
            /* { icon: <ArrowDownTrayIcon className='w-[1.5rem] color-Logout cursor-pointer'/>, action:'download' }, */
            { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action:'view' }, 
            /* { icon: <PencilIcon className='w-[1.5rem] color-Logout cursor-pointer'/>, action:'edit' }, */
        ]
    });

    useEffect(()=>{
        ValidAccessToken()
        getDevelopersBusissneId(state.id);
    },[]);
    
    const onsearchFilter = (nameTap: string) => {
        setOptionActive(nameTap)
    };

    const handleNextPageClick = (e:any) => {

    };

    const onAction = (actionEvent: any) => {
          console.log(actionEvent)
        if(actionEvent.action === 'view') handleOpen(actionEvent.data);
    };

    const handleOpen = (row: any) =>{ 
      console.log(row)
      setdataOperation(row);
      setOpen(true);
    }

    const getDevelopersBusissneId = async(id:number)=>{
      try {

        const response = await requestHttp(
          `/withdrawals/developers/${id}`,
          'GET',
        )

        responseRequest(response);
        
      } catch (err) {
        console.error(err);
      }
    }

    const responseRequest = (response: any) => {
      if([400].includes(response.data.statusCode)){
        setDataTable((prevDataTable) => ({
            ...prevDataTable,
            data: [],
            totalPages: 0
        }));
      }
  
      if([202].includes(response.data.statusCode)){
        const res = response.data['data']['data'];
        const totalPages= response['data']['data']['meta']['pageCount'];
  
        setDataTable((prevDataTable) => ({
            ...prevDataTable,
            data:dataMap(res),
            totalPages: totalPages
        }));
      }
    }

    const dataMap = (row:any) => {
      return row.map((item : any) => {
          return {
              name : item.name, 
              createdAt: formatDate_ddMMYY(item.createdAt),  
              country: ( 
                <>
                  <div>
                    <Flag className="h-[1.0rem] inline-block" code={item.country} />
                    <span className='ml-[10px]'></span>
                  </div>
                </>
              ), 
              countryName:item.country,
              apiKey: item.apiKey,
              apiSecret: '*************',
              id : item.id
          }
      })
    }

    const closeModal = (e:any) => {
        setOpen(e);
    }

    const onGenerateNewKeys = async (actionGenerateKey:string, data:any) => {
      if(['generateKeys'].includes(actionGenerateKey)){
        const newKey : any = await requestHttp(`/withdrawals/new-keys/${state.id}`, 'PUT');

        if(newKey.status === 200){
          const msg = 'process completed successfully';
          setMessage(msg);
          setTimeout(() => {
            setMessage('');
          }, 5000); 
          setdataOperation((prevDataOperation:any) => {
            return {
              ...prevDataOperation,
              apiKey: newKey['data'].apiKey,
              apiSecret: newKey['data'].apiSecret
            };
          });
          getDevelopersBusissneId(state.id);
        }else{
          setdataOperation(data);
        }
      }
      if(['generateKeysShow'].includes(actionGenerateKey)){
        const newKey : any = await requestHttp(`/withdrawals/key-secret/${state.id}`, 'PUT');
        if(newKey.status === 200){
          const msg = '';
          setMessage('');
          setTimeout(() => {
            setMessage('');
          }, 5000);
          setdataOperation((prevDataOperation:any) => {
            return {
              ...prevDataOperation,
              apiSecret: newKey['data']
            };
          });
          getDevelopersBusissneId(state.id);
        }else{
          const msg = 'The private key has already been revealed';
          setMessage(msg);
          setTimeout(() => {
            setMessage('');
          }, 5000);
          setdataOperation(data);
          getDevelopersBusissneId(state.id);
        }
      }
    }

    return (
        <DashboardLayout pageTitle={pagesRouter(location.pathname)} onSearchGen={onSearchGen}>
            <ModalOperation 
              operationDetails={dataOperation} 
              isOpen={open} 
              closeModal={closeModal} 
              typeOperation={'Details Developers'} 
              onGenerateNewKeys={onGenerateNewKeys}
              message={message}
              />
            <SectionTap onsearchFilter={onsearchFilter} datatap={datatap} optionActive={optionActive} />
            <TableGen 
                dataTableGen={dataTable} 
                handleNextPageClick={handleNextPageClick} 
                onAction={onAction}
            />
        </DashboardLayout>
    );
}

export default Developers;